/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetNewbuildingsSummaryModel, IMappers, TGetNewbuildingsSummaryResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsSummaryResponse } from '../../entities/v1_get_newbuildings_summary/GetNewbuildingsSummaryResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsSummaryModel(): TGetNewbuildingsSummaryModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'property-comparison',
    pathApi: '/v1/get-newbuildings-summary/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetNewbuildingsSummaryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetNewbuildingsSummary<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetNewbuildingsSummaryOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsSummaryResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsSummaryModel(),
    config,
  )) as FetchResponse<TGetNewbuildingsSummaryResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsSummaryResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsSummaryResponse>;
}
